import moment from 'moment';
import React, { useState } from 'react';
import { ADJUST_VARIANCE, DEPOSIT, renderCTA } from '.';
import {
  CTA_SIZE,
  CTA_TYPE,
  CURRENT_CURRENCY_SYMBOL,
  DATE_TIME_FORMATS,
} from '../../../../data/constants';
const Body = (props: any) => {
  const { data, formValues, setFormValues, modalState, setModalState } = props;
  const [posFilter, setPosFilter] = useState('');

  function getDepositConfig(mode: string, amount: number) {
    return {
      ctaSize: CTA_SIZE.medium,
      ctaText: DEPOSIT,
      ctaType: CTA_TYPE.primary_cta,
      onCtaClick: () => {
        setFormValues({
          ...formValues,
          transactionType:
            data.status === 'Closed' ? 'Close Deposit' : 'Deposit',
          mode,
          amount,
        });
        setModalState({
          ...modalState,
          header: 'Deposit Amount',
          type: DEPOSIT,
          subText:
            'Deposit the money into your branch account from your cash drawer',
          show: true,
        });
      },
      customClass: 'p-0 pt-10 h-10 ml-25 text-[#397EF5] sm:text-[13px]',
    };
  }

  function getFilterPosOwnConfig(isDisabled: boolean) {
    return {
      ctaSize: CTA_SIZE.medium,
      ctaText: 'Collected By '+data?.userInfo?.userName?.firstName ,
      ctaType:
        posFilter === 'own'
          ? CTA_TYPE.secondary_active_cta
          : CTA_TYPE.secondary_cta,
      onCtaClick: () => setPosFilter( posFilter==='own' ? '' :'own') ,
      isDisabled,
      customClass: 'h-32 ml-auto text-13 font-medium',
    };
  }

  function getfilterPosOtherConfig(isDisabled: boolean) {
    return {
      ctaSize: CTA_SIZE.medium,
      ctaText: 'Collected By Others',
      ctaType:
        posFilter === 'other'
          ? CTA_TYPE.secondary_active_cta
          : CTA_TYPE.secondary_cta,
      isDisabled,
      onCtaClick: () => setPosFilter( posFilter === 'other' ? '' :'other'),
      customClass: 'h-32 ml-12 text-13 font-medium',
    };
  }

  function renderTransactions() {
    return (
      <div className="text-16 font-semibold border-b-[1px] border-black/[0.14] px-40 sm:px-16 pb-20 pt-24 ">
        <div className="mb-20 flex relative">
          Transactions{' '}
          <div className="h-31 bg-black left-[-40px] sm:left-[-16px] absolute">
            &nbsp;
          </div>
        </div>
        {data.transactions?.map((trxn: any, index: number) => {
          return (
            <div
              key={index}
              className={
                data.transactions.length - 1 !== index
                  ? 'border-b-[1px] mb-20 pb-20'
                  : ''
              }
            >
              <div className="flex w-full font-medium text-14 text-black/70">
                <div className="w-[90%]"> {trxn.transactionType}</div>
                <div>
                  {CURRENT_CURRENCY_SYMBOL}
                  {trxn.amount}
                </div>
              </div>
              <div className="mt-10 font-normal text-13 text-black/[0.48]">
                On{' '}
                {moment(trxn.updatedBy.date).format(
                  DATE_TIME_FORMATS.yearMonthDayTime
                )}{' '}
                by {trxn.updatedBy?.userName?.firstName}
              </div>
            </div>
          );
        })}
        {data?.transactions?.length === 0 && (
          <div className="text-14 font-normal text-black/[0.48] mt-15 ">
            No transactions
          </div>
        )}
      </div>
    );
  }

  function renderPosCollections() {
    let others = Object.entries(data?.others || {}),
      my_collections = Object.entries(data?.myself || {});
    let actual_data = posFilter === 'own' ? my_collections : posFilter === 'other' ?  others : [];
    if (actual_data.length === 0 && data?.collections?.length > 0) {
      actual_data = data.collections.length
        ? data.collections
        : [];
    }
    return (
      <div className="text-16 font-semibold px-40 sm:px-16 border-b-[1px] pt-24 pb-20 ">
        <div className="mb-20 flex">
          <div className="relative flex">
            POS Collections
            <div className="h-31 bg-black left-[-40px] sm:left-[-16px] absolute">
              &nbsp;
            </div>
          </div>
          {my_collections.length + others.length > 0 && (
            <>
              {renderCTA(getFilterPosOwnConfig(my_collections.length === 0))}
              {renderCTA(getfilterPosOtherConfig(others.length === 0))}
            </>
          )}
        </div>
        {actual_data.map((trxn: any, index: number) => {
          return (
            <div
              key={index}
              className={
                actual_data.length - 1 !== index
                  ? 'border-b-[1px] mb-20 pb-20'
                  : ''
              }
            >
              <div className="flex w-full font-medium text-14 text-black/70">
                <div className="w-[90%]"> {trxn?.mode || trxn[0]}</div>
                <div>
                  {CURRENT_CURRENCY_SYMBOL}
                  {trxn?.amount || trxn[1]}
                </div>
              </div>
            </div>
          );
        })}
        {data?.collections?.length === 0 &&
          my_collections.length + others.length === 0 && (
            <div className="text-14 font-normal text-black/[0.48] mt-15 mb-0">
              No pos collections
            </div>
          )}
      </div>
    );
  }

  function getToolTiptext() {
    return data.status === 'Open'
      ? 'You can withdraw amount from cash drawer and deposit to your branch account'
      : 'Deposit the balance amount to your branch account to clear the balance dues';
  }

  function getAdjustVarianceConfig(mode: string, amount: number) {
    return {
      ctaSize: CTA_SIZE.medium,
      ctaText: 'ADJUST VARIANCE',
      ctaType: CTA_TYPE.primary_cta,
      onCtaClick: () => {
        setFormValues({
          ...formValues,
          transactionType: 'Open Float',
          mode,
          amount,
        });
        setModalState({
          ...modalState,
          header: 'Adjust Variance',
          type: ADJUST_VARIANCE,
          subText:
            'Please enter the adjustment amount to clear the opening variance',
          show: true,
        });
      },
      customClass: 'p-0 pt-10 h-10 ml-25 sm:text-[13px] text-[#EF4424]',
    };
  }

  function renderVariances(opening = false) {
    let renderData = opening ? data.openingVariances : data.variances;
    return (
      <div className="text-16 font-semibold border-b-[1px] px-40 sm:px-16 pt-24 pb-20">
        <div className="relative flex">
          {opening
            ? 'Opening Variances'
            : data.status === 'Open'
            ? 'Cash Drawer Balance'
            : 'Balances'}
          <div className="h-31 bg-black left-[-40px] sm:left-[-16px] absolute">
            &nbsp;
          </div>
        </div>
        {renderData?.length > 0 ? (
          renderData.map((variance: any, index: any) => {
            return (
              <div
                key={index}
                className="flex text-14 font-medium text-black/70 mt-15"
              >
                <div>{variance.mode}</div>
                <div
                  className={`ml-auto ${
                    !opening && data.status === 'Open'
                      ? 'text-black'
                      : 'text-[#EF4424]'
                  }`}
                >
                  {CURRENT_CURRENCY_SYMBOL}
                  {opening ? -1 * variance.amount : variance.amount}
                </div>
                {opening ? (
                  renderCTA(
                    getAdjustVarianceConfig(variance.mode, variance.amount)
                  )
                ) : (
                  <>
                    {renderCTA(
                      getDepositConfig(variance.mode, variance.amount)
                    )}
                    <div
                      title={getToolTiptext()}
                      className={`rista-sprite ic-info-blue ml-5 mt-1 shrink-0`}
                    ></div>
                  </>
                )}
              </div>
            );
          })
        ) : (
          <div className="text-14 font-normal text-black/[0.48] mt-15">
            {data.status === 'Closed' || !opening
              ? 'No balance'
              : 'No opening Variance'}
          </div>
        )}
      </div>
    );
  }

  function renderExpenses() {
    const renderData = data?.localTransactions || [];
     return (
      <div className="flex px-40 sm:px-16  flex-col pt-24 ">
      <div className="text-16 font-semibold relative flex pb-20 ">
        Expenses{' '}
        <div className="h-31 bg-black left-[-40px] sm:left-[-16px] absolute">
          &nbsp;
        </div>
      </div>
       {
        renderData.map((data:any) => {
          return data.mode === 'Cash' && (
            <div className='flex items-center justify-between text-14 mt-20 border-b-[1px] border-black/[0.14]'>
              <div className='flex flex-col mb-20'>
                <span className='font-normal text-14'>
                  {data?.transactionType || ''}
                </span>
                <span className='mt-10 font-normal text-13 text-black/[0.48]'>
                  {data?.reason + ' On ' + data?.transactionDate}
                </span>
              </div>
              <div className='mb-20'>
                {data?.amount}
              </div>
            </div>
          )
        })
       }
      </div>
     )
  }

  function renderEventLog() {
    return (
      <div className="flex px-40 sm:px-16 pb-[50px] flex flex-col pt-24 ">
        <div className="text-16 font-semibold relative flex pb-20 ">
          Event Log{' '}
          <div className="h-31 bg-black left-[-40px] sm:left-[-16px] absolute">
            &nbsp;
          </div>
        </div>
        {data?.eventLog?.map((value: any, index: any) => {
          return (
            <div key={index} className="flex mb-11 font-medium text-14 justify-between">
              <div className="flex ">
                <div className="text-black/70">{value.status}</div>
                <div className='ml-4'> by {value.eventBy.userName.firstName}</div>
              </div>
              <div className="">
                {moment(value.eventBy.date).format(
                  DATE_TIME_FORMATS.yearMonthDayTime
                )}
              </div>
            </div>
          );
        })}
        {(!data?.eventLog || data?.eventLog?.length === 0) && (
          <div className="text-14 font-normal text-black/[0.48] mt-15 sm:mt-0">
            No Events
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="ml-30 sm:ml-[15px] sm:mr-[20px] mb-[80px] sm:mb-0 border-[1px] border-black/[14%] rounded-[8px] w-[56%] sm:w-[94%] overflow-scroll">
      {renderVariances()}
      {renderVariances(true)}
      {renderTransactions()}
      {renderPosCollections()}
      {renderExpenses()}
      {renderEventLog()}
    </div>
  );
};
export default Body;
